import { render } from "./PineCharacter.vue?vue&type=template&id=1f856009&scoped=true"
import script from "./PineCharacter.vue?vue&type=script&lang=js"
export * from "./PineCharacter.vue?vue&type=script&lang=js"

import "./PineCharacter.vue?vue&type=style&index=0&id=1f856009&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f856009"]])

export default __exports__